import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ToastMsg from "../../components/ToastMsg";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import Dropdown from "../../components/Dropdown";
import Toggle from "../../components/Toggle";
import Footer from "../../components/Footer";
import Slider from "../../components/Slider";
import SettingNav from "../../components/settingNav";

const SettingsLegalProceedingsPage = () => {
  const navigate = useNavigate();
  const [isToastMsgOpen, setToastMsgOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openToastMsg = useCallback(() => {
    setToastMsgOpen(true);
  }, []);

  const closeToastMsg = useCallback(() => {
    setToastMsgOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const breadcrumb = [
    { label: "", path: "/postlba", icon: "assets/home.svg", active: true },
    { label: "Settings", path: "", icon: "", active: false },
    { label: "Legal proceedings", path: "", icon: "", active: true },
  ];

  const dropdownContents = [
    "County Court Business Centre (CCBC)",
    "Local Court",
  ];
  const dropdownContents2 = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const handleToggle = (state) => {
    console.log("Toggle state is:", state);
  };

  const billingOptions = ["Daily", "Weekly", "Monthly", "Annually"];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-font-family-meta-strong">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main */}
        <div className="w-full absolute top-[128px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          <Breadcrumb breadcrumbs={breadcrumb} />
          {/* Heading */}
          <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5 text-9xl text-primary-primary-900">
            <b className="self-stretch relative">Settings</b>
            <div className="self-stretch relative text-base text-neutrals-neutral-300">
              Get your billing information, generate/review invoices.
            </div>
          </div>
          <div className="self-stretch flex flex-row items-start justify-start gap-8 text-base">
            <SettingNav />

            <div className="flex-1 flex flex-col items-start justify-start gap-6 text-lg text-Neutrals-neutral-900">
              <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
                <div className="flex-1 flex flex-col items-start justify-start gap-1.5">
                  <div className="self-stretch relative font-semibold">
                    Invoice reminder
                  </div>
                  <div className="self-stretch relative text-sm text-neutrals-neutral-300">
                    Allow users to configure how and when communication is
                    initiated with debtors.
                  </div>
                </div>
                <div className="flex flex-row items-start justify-start gap-3 text-sm">
                  <CTAs
                    type="Ghostbtn"
                    text="Cancel"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    position="relative"
                  />

                  <CTAs
                    type="Primarybtn"
                    text="Save"
                    textColor="text-neutrals-neutral-50"
                    bgColor="bg-primary-primary-500"
                    borderColor="border-primary-primary-500"
                    position="relative"
                    onClick={openToastMsg}
                  />
                </div>
              </div>
              <div className="self-stretch flex flex-col items-start justify-start gap-8 text-base">
                <div className="self-stretch flex flex-col items-start justify-start gap-6">
                  <div className="self-stretch flex flex-row items-start justify-start gap-4">
                    <div className="relative font-semibold">
                      Enable reminders
                    </div>
                    <Toggle
                      onToggle={handleToggle}
                      isOn={true}
                      onColor="bg-primary-primary-500"
                      offColor="bg-primary-primary-50"
                      knobColor="bg-neutrals-neutral-50"
                    />
                  </div>
                  <div className="self-stretch flex flex-col items-start justify-start gap-6 text-sm">
                    <div className="self-stretch flex flex-row items-center justify-start gap-6 text-base">
                      <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6">
                        <div className="self-stretch flex flex-row items-start justify-between gap-0">
                          <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                            <img
                              className="w-5 relative h-5"
                              alt=""
                              src="assets/judge.svg"
                            />
                          </div>
                          {/* Toggle */}
                          <Toggle
                            onToggle={handleToggle}
                            isOn={true}
                            onColor="bg-primary-primary-500"
                            offColor="bg-primary-primary-50"
                            knobColor="bg-neutrals-neutral-50"
                          />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-1.5">
                          <div className="relative font-semibold">
                            Court involvement
                          </div>
                          <div className="w-[294px] relative text-neutrals-neutral-300 inline-block">
                            Lorem ipsum dolor sit amet consectetur. Nullam nec
                            et dolor.
                          </div>
                        </div>
                      </div>
                      <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6">
                        <div className="self-stretch flex flex-row items-start justify-between gap-0">
                          <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                            <img
                              className="w-5 relative h-5 overflow-hidden shrink-0"
                              alt=""
                              src="assets/ai.svg"
                            />
                          </div>
                          {/* Toggle */}
                          <Toggle
                            onToggle={handleToggle}
                            isOn={true}
                            onColor="bg-primary-primary-500"
                            offColor="bg-primary-primary-50"
                            knobColor="bg-neutrals-neutral-50"
                          />
                        </div>
                        <div className="flex flex-col items-start justify-start gap-1.5">
                          <div className="relative font-semibold">
                            Automatic case submission
                          </div>
                          <div className="w-[294px] relative text-neutrals-neutral-300 inline-block">
                            Lorem ipsum dolor sit amet consectetur. Nullam nec
                            et dolor.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-[400px] flex flex-col items-start justify-start gap-2.5">
                      <Dropdown
                        title="Select type of court"
                        icon="assets/help-circle.svg"
                        placeholder="Select court type"
                        dropdownContents={dropdownContents}
                      />
                    </div>
                    <div className="self-stretch flex flex-col items-start justify-start gap-2.5">
                      <div className="flex flex-row items-center justify-start gap-1.5">
                        <div className="relative font-semibold">
                          Court location
                        </div>
                        <img
                          className="w-5 relative h-5 overflow-hidden shrink-0"
                          alt=""
                          src="assets/help-circle.svg"
                        />
                      </div>
                      <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border h-[282px] flex flex-col items-start justify-start p-4 text-base text-neutrals-neutral-300">
                        <div className="relative">
                          Enter the details for court location
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="self-stretch relative border-neutrals-neutral-100 border-solid border-t-[1px] box-border h-px" />
                {/* Billing schedule */}
                <div className="self-stretch flex flex-col items-start justify-start gap-6">
                  <div className="self-stretch flex flex-col items-start justify-start gap-1.5">
                    <div className="relative font-semibold">
                      Billing schedule
                    </div>
                    <div className="relative text-neutrals-neutral-300">
                      Customise billing schedules for solicitors.
                    </div>
                  </div>
                  <div className="self-stretch flex flex-col items-start justify-start gap-6 text-sm">
                    <Slider options={billingOptions} />
                    <div className="self-stretch flex flex-col items-start justify-start gap-2.5">
                      <Dropdown
                        title="Select billing day"
                        icon="assets/help-circle.svg"
                        placeholder="Select day"
                        dropdownContents={dropdownContents2}
                      />
                    </div>
                  </div>
                </div>
                <div className="self-stretch relative border-neutrals-neutral-100 border-solid border-t-[1px] box-border h-px" />
                {/* Court notifications */}
                <div className="self-stretch flex flex-col items-start justify-start gap-6">
                  <div className="self-stretch flex flex-col items-start justify-start gap-1.5">
                    <div className="self-stretch relative font-semibold">
                      Court notifications preferences
                    </div>
                    <div className="self-stretch relative text-neutrals-neutral-300">
                      Customise billing schedules for solicitors.
                    </div>
                  </div>
                  <div className="self-stretch flex flex-row items-start justify-start gap-6">
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6">
                      <div className="self-stretch flex flex-row items-start justify-between gap-0">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/calendar.svg"
                          />
                        </div>
                        {/* Toggle */}
                        <Toggle
                          onToggle={handleToggle}
                          isOn={true}
                          onColor="bg-primary-primary-500"
                          offColor="bg-primary-primary-50"
                          knobColor="bg-neutrals-neutral-50"
                        />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-1.5">
                        <div className="relative font-semibold">
                          Court date reminder
                        </div>
                        <div className="w-[294px] relative text-neutrals-neutral-300 inline-block">
                          Get notified before your court date so you can be
                          prepared in advance.
                        </div>
                      </div>
                    </div>
                    <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6">
                      <div className="self-stretch flex flex-row items-start justify-between gap-0">
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                          <img
                            className="w-5 relative h-5"
                            alt=""
                            src="assets/bill.svg"
                          />
                        </div>
                        {/* Toggle */}
                        <Toggle
                          onToggle={handleToggle}
                          isOn={true}
                          onColor="bg-primary-primary-500"
                          offColor="bg-primary-primary-50"
                          knobColor="bg-neutrals-neutral-50"
                        />
                      </div>
                      <div className="flex flex-col items-start justify-start gap-1.5">
                        <div className="relative font-semibold">
                          Billing notifications
                        </div>
                        <div className="w-[294px] relative text-neutrals-neutral-300 inline-block">
                          Get notified about your billing reminders.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isToastMsgOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeToastMsg}
        >
          <ToastMsg onClose={closeToastMsg} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default SettingsLegalProceedingsPage;
